import { createContext } from 'react';
const debug = process.env.REACT_APP_DEBUG && false;
export const UseObservationsContext = createContext({
    save: (observationHistory) => { },
    deleteObject: () => { },
    working: false,
    querying: false,
    errMessage: undefined,
});
